export const env: { [s: string]: (string | null); } = {
  'npm_package_version': '4.3.4',
};
